import {createSlice, createAsyncThunk,
	PayloadAction}							from '@reduxjs/toolkit';

import {UsersState}							from './interface';
import {User}								from '../user/interface';
import {UploadDocument, UploadPercentState}	from '../documents/interface';
import actions 								from './companyUsersAction';


const initialState: UsersState = {
	isLoad:         false,
	isLoadPut:      false,
	data:           [],
	uploadDocument: []
};

export const getCompanyUsersApi = createAsyncThunk('companyUsers/getCompanyUsersApi', actions.getCompanyUsersApi);
export const postCompanyUsersApi = createAsyncThunk('companyUsers/postCompanyUsersApi', actions.postCompanyUsersApi);
export const putCompanyUsersApi = createAsyncThunk('companyUsers/putCompanyUsersApi', actions.putCompanyUsersApi);
export const uploadProfilePictureApi = createAsyncThunk('companyUsers/uploadProfilePicture', actions.uploadProfilePicture);
export const deleteCompanyUsersApi = createAsyncThunk('companyUsers/deleteCompanyUsersApi', actions.deleteCompanyUsersApi);

export const Reducer = createSlice({
	name:     'companyUsers',
	initialState,
	reducers: {
		pushUpload: (state, action: PayloadAction<UploadDocument>) => {
			action.payload.isClose = false;
			state.uploadDocument.push(action.payload);
		},
		setUploadPercent: (state, action: PayloadAction<UploadPercentState>) => {
			if (state.uploadDocument[action.payload.index])
				state.uploadDocument[action.payload.index].percent = action.payload.percent;
		},
		closeUpload: (state, action: PayloadAction<number>) => {
			if (state.uploadDocument[action.payload])
				state.uploadDocument[action.payload].isClose = true;
		}
	},
	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getCompanyUsersApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getCompanyUsersApi.fulfilled, (state, action) => {
			return ({
				...state,
				isLoad: false,
				data:   action.payload
			});
		})
		// --- POST
		.addCase(postCompanyUsersApi.fulfilled, (state, action) => {
			if (action.payload?._id && !action.payload?.error)
				state.data.push(action.payload);
		})

		.addCase(uploadProfilePictureApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return;

			const copy: User[] = state.data.map((user) => {
				if (user && action.payload._id === user._id)
					return {...user, profilePicture: action.payload.profilePicture};
				return user;
			});

			return ({...state, data: copy});
		})
		// --- PUT
		.addCase(putCompanyUsersApi.pending, (state) => {
			state.isLoadPut = true;
		})
		.addCase(putCompanyUsersApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoadPut: false});

			const copy: User[] = state.data.map((user) => {
				if (user && action.payload._id === user._id)
					return {...user, ...action.payload};
				return user;
			});

			return ({
				...state,
				data:      copy,
				isLoadPut: false
			});
		})
		// --- DELETE
		.addCase(deleteCompanyUsersApi.fulfilled, (state, action) => {
			const index = state.data.findIndex(find => find?._id === action?.payload);
			const copy = [...state.data];

			if (index !== -1)
				copy.splice(index, 1);
			return ({...state, data: copy});
		});
	}
});

// export const {logout} = Reducer.actions;

export default Reducer.reducer;
